// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"c1a57fc068c6f425b1e6","293":"9b515299394ca3367e59","518":"9e1e28ae747165f8d57f","779":"9e6c4946ee3c0bd8484f"}[chunkId] + ".js";
};